import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UIRouterModule } from '@uirouter/angular';

import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';

import { VbUiThumbnailSheetPreviewComponent } from './VbUiThumbnailSheetPreview.Component';

const declarations = [
	VbUiThumbnailSheetPreviewComponent
];

@NgModule({
	declarations: declarations,
	exports: declarations,
	imports: [
		CommonModule,
		DirectivesAngularModule,
		UIRouterModule
	]
})
export class ThumbnailSheetPreviewModule {}
